import { AppStoresButton, DownloadAppQRCode, Text, YStack } from '@frontend/web-react';
import { useAnalytics } from '@frontend/web/hooks';

export const DownloadAppLink = ({ platform }: { platform: MobilePlatform }) => {
  const { track } = useAnalytics();
  const event = platform === 'ios' ? 'iosDownloadLinkSelected' : 'androidDownloadLinkSelected';
  return (
    <YStack alignItems="center" gap="sm" justifyContent="center">
      <DownloadAppQRCode platform={platform} />
      <Text type="captionBold">Scan to download</Text>
      <AppStoresButton onClick={() => track({ event, topic: 'onboarding' })} platform={platform} />
    </YStack>
  );
};
